import { ConfigComponents } from './configComponents';
import { Allow as AllowMap} from './allow';
import { pathRoutes as Routes } from './pathRoutes';
const Allow = AllowMap();

export const mapRoutes = (view) => [
    {
        path: Routes.OBJECT_ORGANIZATION,
        allow: view?.allow?.includes(Allow?.ObjectOrganization?.allow),
        component: ConfigComponents.OBJECT_ORGANIZATION,
        exact: true
    },
    {
        path: Routes.INFORMATION,
        allow: view?.allow?.includes(Allow?.InformationPanel?.allow),
        component: ConfigComponents.INFORMATION,
        exact: true
    },
    {
        path: Routes.FINANCE_REPORT,
        allow: view?.allow?.includes(Allow?.FinanceReport?.allow),
        component: ConfigComponents.FINANCE_REPORT,
        exact: true
    },
    {
        path: Routes.JACKPOT_REPORT,
        allow: view?.allow?.includes(Allow?.JackpotReport?.allow),
        component: ConfigComponents.JACKPOT_REPORT,
        exact: true
    },
    {
        path: Routes.BONUSES_REPORT,
        allow: view?.allow?.includes(Allow?.BonusesReport?.allow),
        component: ConfigComponents.BONUSES_REPORT,
        exact: true
    },
    {
        path: Routes.BALANCE_REPORT,
        allow: view?.allow?.includes(Allow?.BalanceReport?.allow),
        component: ConfigComponents.BALANCE_REPORT,
        exact: true
    },
    {
        path: Routes.EVENT_REPORT,
        allow: view?.allow?.includes(Allow?.EventReport?.allow),
        component: ConfigComponents.EVENT_REPORT,
        exact: true
    },
    {
        path: Routes.JACKPOT,
        allow: view?.allow?.includes(Allow?.Jackpot?.allow),
        component: ConfigComponents.JACKPOT,
        exact: true
    },
    {
        path: Routes.JACKPOT_CREATE,
        allow: view?.allow?.includes(Allow?.Jackpot?.allow),
        component: ConfigComponents.JACKPOT_CREATE,
        exact: true
    },
    {
        path: Routes.JACKPOT_EDIT,
        allow: view?.allow?.includes(Allow?.Jackpot?.allow),
        component: ConfigComponents.JACKPOT_EDIT,
        exact: true
    },
    {
        path: Routes.TOURNAMENT_LIST,
        allow: view?.allow?.includes(Allow?.Tournament?.allow),
        component: ConfigComponents.TOURNAMENT_LIST,
        exact: true
    },
    {
        path: Routes.TOURNAMENT_CREATE,
        allow: view?.allow?.includes(Allow?.Tournament?.allow),
        component: ConfigComponents.TOURNAMENT_CREATE,
        exact: true
    },
    {
        path: Routes.TOURNAMENT_EDIT,
        allow: view?.allow?.includes(Allow?.Tournament?.allow),
        component: ConfigComponents.TOURNAMENT_EDIT,
        exact: true
    },
    {
        path: Routes.TOURNAMENT_STAT,
        allow: view?.allow?.includes(Allow?.Tournament?.allow),
        component: ConfigComponents.TOURNAMENT_STAT,
        exact: true
    },
    {
        path: Routes.REFERRAL,
        allow: view?.allow?.includes(Allow?.Referral?.allow),
        component: ConfigComponents.REFERRAL,
        exact: true
    },
    {
        path: Routes.REFERRAL_PROMOCODE,
        allow: view?.allow?.includes(Allow?.Referral?.allow),
        component: ConfigComponents.REFERRAL_PROMOCODE,
        exact: true
    },
    {
        path: Routes.GAMES_PROVIDER_REPORT,
        allow: view?.allow?.includes(Allow?.ReportProvider?.allow),
        component: ConfigComponents.GAMES_PROVIDER_REPORT,
        exact: true
    },
    {
        path: Routes.GAMES_CREDIT,
        allow: view?.allow?.includes(Allow?.CreditLine?.allow),
        component: ConfigComponents.GAMES_CREDIT,
        exact: true
    },
    {
        path: Routes.HISTORY_CREDIT,
        allow: view?.allow?.includes(Allow?.HistoryReplenishment?.allow),
        component: ConfigComponents.HISTORY_CREDIT,
        exact: true
    },
    {
        path: Routes.GAMES_SEARCH,
        allow: view?.allow?.includes(Allow?.GamesSearch?.allow),
        component: ConfigComponents.GAMES_SEARCH,
        exact: true
    },
    {
        path: Routes.PAYMENT_SYSTEM,
        allow: view?.allow?.includes(Allow?.PaymentSystem?.allow),
        component: ConfigComponents.PAYMENT_SYSTEM,
        exact: true
    },
    {
        path: Routes.WITHDRAWALS,
        allow: view?.allow?.includes(Allow?.Withdrawals?.allow),
        component: ConfigComponents.WITHDRAWALS,
        exact: true
    },
    {
        path: Routes.REPLENISHMENT_REPORT,
        allow: view?.allow?.includes(Allow?.ReplenishmentReport?.allow),
        component: ConfigComponents.REPLENISHMENT_REPORT,
        exact: true
    },
    {
        path: Routes.REPLENISHMENT_GENERAL_REPORT,
        allow: view?.allow?.includes(Allow?.ReplenishmentReport?.allow),
        component: ConfigComponents.REPLENISHMENT_GENERAL_REPORT,
        exact: true
    },
    {
        path: Routes.REPLENISHMENT_GAMER_REPORT,
        allow: view?.allow?.includes(Allow?.GamerReport?.allow),
        component: ConfigComponents.REPLENISHMENT_GAMER_REPORT,
        exact: true
    },
    {
        path: Routes.REPLENISHMENT_TRANSACTION,
        allow: view?.allow?.includes(Allow?.ReplenishmentReport?.allow),
        component: ConfigComponents.REPLENISHMENT_TRANSACTION,
        exact: true
    },
    {
        path: Routes.GAMER_REPORT,
        allow: view?.allow?.includes(Allow?.Gamer?.allow),
        component: ConfigComponents.GAMER_REPORT,
        exact: true
    },
    {
        path: Routes.GAMER_LIST_ID,
        allow: view?.allow?.includes(Allow?.Gamer?.allow),
        component: ConfigComponents.GAMER_LIST_ID,
        exact: true
    },
    {
        path: Routes.GAMER_LIST,
        allow: view?.allow?.includes(Allow?.Gamer?.allow),
        component: ConfigComponents.GAMER_LIST,
        exact: true
    },
    {
        path: Routes.GAMER_REPORT_EVENT,
        allow: view?.allow?.includes(Allow?.Gamer?.allow),
        component: ConfigComponents.GAMER_REPORT_EVENT,
        exact: true
    },
    {
        path: Routes.GAMER_REPORT_GAME,
        allow: view?.allow?.includes(Allow?.Gamer?.allow),
        component: ConfigComponents.GAMER_REPORT_GAME,
        exact: true
    },
    {
        path: Routes.KYC,
        allow: view?.allow?.includes(Allow?.Kyc?.allow),
        component: ConfigComponents.KYC,
        exact: true
    },
    {
        path: Routes.BONUS,
        allow: view?.allow?.includes(Allow?.Bonuses?.allow),
        component: ConfigComponents.BONUS,
        exact: true
    },
    {
        path: Routes.BONUS_TEMPLATE,
        allow: view?.allow?.includes(Allow?.Bonuses?.allow),
        component: ConfigComponents.BONUS_TEMPLATE,
        exact: true
    },
    {
        path: Routes.BONUS_SETTINGS,
        allow: view?.allow?.includes(Allow?.Bonuses?.allow),
        component: ConfigComponents.BONUS_SETTINGS,
        exact: true
    },
    {
        path: Routes.PERSONAL_BONUS,
        allow: view?.allow?.includes(Allow?.PersonalBonuses?.allow),
        component: ConfigComponents.PERSONAL_BONUS,
        exact: true
    },
    {
        path: Routes.PERSONAL_BONUS_CREATE,
        allow: view?.allow?.includes(Allow?.PersonalBonuses?.allow),
        component: ConfigComponents.PERSONAL_BONUS_CREATE,
        exact: true
    },
    {
        path: Routes.PRESENT_CONFIRMATION,
        allow: view?.allow?.includes(Allow?.PresentConfirmation?.allow),
        component: ConfigComponents.PRESENT_CONFIRMATION,
        exact: true
    },
    {
        path: Routes.CASHIER_USERS,
        allow: view?.allow?.includes(Allow?.CashierUsers?.allow),
        component: ConfigComponents.CASHIER_USERS,
        exact: true
    },
    {
        path: Routes.CASHIER_SHIFT,
        allow: view?.allow?.includes(Allow?.CashierReport?.allow),
        component: ConfigComponents.CASHIER_SHIFT,
        exact: true
    },
    {
        path: Routes.CASHIER_DAILY,
        allow: view?.allow?.includes(Allow?.CashierFinance?.allow),
        component: ConfigComponents.CASHIER_DAILY,
        exact: true
    },
    {
        path: Routes.CASHIER_DAILY_ID,
        allow: view?.allow?.includes(Allow?.CashierFinance?.allow),
        component: ConfigComponents.CASHIER_DAILY_ID,
        exact: true
    },
    {
        path: Routes.CASHIER_GROUP,
        allow: view?.allow?.includes(Allow?.CashierGroup?.allow),
        component: ConfigComponents.CASHIER_GROUP,
        exact: true
    },
    {
        path: Routes.CASHIER_GROUP_ID,
        allow: view?.allow?.includes(Allow?.CashierGroup?.allow),
        component: ConfigComponents.CASHIER_GROUP_ID,
        exact: true
    },
    {
        path: Routes.SUPPORT,
        allow: view?.allow?.includes(Allow?.Support?.allow),
        component: ConfigComponents.SUPPORT,
        exact: true
    },
    {
        path: Routes.WITHDRAWALS_OPERATION,
        allow: view?.allow?.includes(Allow?.WithdrawalsOperations?.allow),
        component: ConfigComponents.WITHDRAWALS_OPERATION,
        exact: true
    },
    {
        path: Routes.LOTTERY_LIST,
        allow: view?.allow?.includes(Allow?.Lottery?.allow),
        component: ConfigComponents.LOTTERY_LIST,
        exact: true
    },
    {
        path: Routes.LOTTERY_CREATE,
        allow: view?.allow?.includes(Allow?.Lottery?.allow),
        component: ConfigComponents.LOTTERY_CREATE,
        exact: true
    },
    {
        path: Routes.LOTTERY_EDIT,
        allow: view?.allow?.includes(Allow?.Lottery?.allow),
        component: ConfigComponents.LOTTERY_EDIT,
        exact: true
    },
    {
        path: Routes.LOTTERY_STAT,
        allow: view?.allow?.includes(Allow?.Lottery?.allow),
        component: ConfigComponents.LOTTERY_STAT,
        exact: true
    },
    {
        path: Routes.LOTTERY_PRIZE,
        allow: view?.allow?.includes(Allow?.Lottery?.allow),
        component: ConfigComponents.LOTTERY_PRIZE,
        exact: true
    },
    {
        path: Routes.SECURITY_ADMIN_LIST,
        allow: view?.allow?.includes(Allow?.SecurityAdmin?.allow),
        component: ConfigComponents.SECURITY_ADMIN_LIST,
        exact: true
    },
    {
        path: Routes.SECURITY_ADMIN_VIEW,
        allow: view?.allow?.includes(Allow?.SecurityAdmin?.allow),
        component: ConfigComponents.SECURITY_ADMIN_VIEW,
        exact: true
    },
    {
        path: Routes.SECURITY_SIGNIN_HISTORY,
        allow: view?.allow?.includes(Allow?.SecurityHistorySignin?.allow),
        component: ConfigComponents.SECURITY_SIGNIN_HISTORY,
        exact: true
    },
    {
        path: Routes.SECURITY_EVENT_HISTORY,
        allow: view?.allow?.includes(Allow?.SecurityHistoryEvent?.allow),
        component: ConfigComponents.SECURITY_EVENT_HISTORY,
        exact: true
    },
    {
        path: Routes.FREESPIN_ISSUE,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_ISSUE,
        exact: true
    },
    {
        path: Routes.FREESPIN_LIST,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_LIST,
        exact: true
    },
    {
        path: Routes.FREESPIN_VIEW,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_VIEW,
        exact: true
    },
    {
        path: Routes.FREESPIN_GAME,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_GAME,
        exact: true
    },
    {
        path: Routes.FREESPIN_GAME_CREATE,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_GAME_CREATE,
        exact: true
    },
    {
        path: Routes.FREESPIN_GAME_EDIT,
        allow: view?.allow?.includes(Allow?.Freespin?.allow),
        component: ConfigComponents.FREESPIN_GAME_EDIT,
        exact: true
    },
    {
        path: Routes.KEYS,
        allow: view?.allow?.includes(Allow?.KEYS?.allow),
        component: ConfigComponents.KEYS,
        exact: true
    },
    {
        path: Routes.SETTINGS_MESSANGER,
        allow: view?.allow?.includes(Allow?.SettingsMessanger?.allow),
        component: ConfigComponents.SETTINGS_MESSANGER,
        exact: true
    },
    {
        path: Routes.SETTINGS_MESSANGER_CREATE,
        allow: view?.allow?.includes(Allow?.SettingsMessanger?.allow),
        component: ConfigComponents.SETTINGS_MESSANGER_CREATE,
        exact: true
    },
    {
        path: Routes.SETTINGS_MESSANGER_EDIT,
        allow: view?.allow?.includes(Allow?.SettingsMessanger?.allow),
        component: ConfigComponents.SETTINGS_MESSANGER_EDIT,
        exact: true
    },
    {
        path: Routes.SETTINGS_EXCHANGE,
        allow: view?.allow?.includes(Allow?.SettingsExchange?.allow),
        component: ConfigComponents.SETTINGS_EXCHANGE,
        exact: true
    },
    {
        path: Routes.SETTINGS_EXCHANGE_CREATE,
        allow: view?.allow?.includes(Allow?.SettingsExchange?.allow),
        component: ConfigComponents.SETTINGS_EXCHANGE_CREATE,
        exact: true
    },
    {
        path: Routes.SETTINGS_EXCHANGE_EDIT,
        allow: view?.allow?.includes(Allow?.SettingsExchange?.allow),
        component: ConfigComponents.SETTINGS_EXCHANGE_EDIT,
        exact: true
    },
    {
        path: Routes.PINSALE,
        allow: view?.allow?.includes(Allow?.Pinsale?.allow),
        component: ConfigComponents.PINSALE,
        exact: true
    },
    {
        path: Routes.PINSALE_CREATE,
        allow: view?.allow?.includes(Allow?.Pinsale?.allow),
        component: ConfigComponents.PINSALE_CREATE,
        exact: true
    },
    {
        path: Routes.STATISTICS,
        allow: view?.allow?.includes(Allow?.Statistics?.allow),
        component: ConfigComponents.STATISTICS,
        exact: true
    },
    {
        path: Routes.CODE_COUNTRY,
        allow: view?.allow?.includes(Allow?.SettingsCodeCountry?.allow),
        component: ConfigComponents.CODE_COUNTRY_LIST,
        exact: true
    },
    {
        path: Routes.CODE_COUNTRY_CREATE,
        allow: view?.allow?.includes(Allow?.SettingsCodeCountry?.allow),
        component: ConfigComponents.CODE_COUNTRY_CREATE,
        exact: true
    },
    {
        path: Routes.CURRENCY_LIST,
        allow: view?.allow?.includes(Allow?.SettingsCurrency?.allow),
        component: ConfigComponents.CURRENCY_LIST,
        exact: true
    },
    {
        path: Routes.CURRENCY_CREATE,
        allow: view?.allow?.includes(Allow?.SettingsCurrency?.allow),
        component: ConfigComponents.CURRENCY_CREATE,
        exact: true
    },
    {
        path: Routes.RULES_LIST,
        allow: true,
        component: ConfigComponents.RULES_LIST,
        exact: true
    },
    {
        path: Routes.RULES_CREATE,
        allow: true,
        component: ConfigComponents.RULES_CREATE,
        exact: true
    },
    {
        path: Routes.DICTIONARY_LIST,
        allow: true,
        component: ConfigComponents.DICTIONARY_LIST,
        exact: true
    },
    {
        path: Routes.DICTIONARY_CREATE,
        allow: true,
        component: ConfigComponents.DICTIONARY_CREATE,
        exact: true
    },
    {
        path: Routes.CASHBACK,
        allow: true,
        component: ConfigComponents.CASHBACK,
        exact: true
    },
    {
        path: Routes.GAMES_LIST,
        allow: true,
        component: ConfigComponents.GAMES_LIST,
        exact: true,
    },
    {
        path: Routes.GAMES_CREATE,
        allow: true,
        component: ConfigComponents.GAMES_CREATE,
        exact: true,
    },
    {
        path: Routes.GAMES_EDIT,
        allow: true,
        component: ConfigComponents.GAMES_EDIT,
        exact: true,
    },
    {
        path: Routes.PROVIDERS_LIST,
        allow: true,
        component: ConfigComponents.PROVIDERS_LIST,
        exact: true,
    },
    {
        path: Routes.PROVIDERS_CREATE,
        allow: true,
        component: ConfigComponents.PROVIDERS_CREATE,
        exact: true,
    },
    {
        path: Routes.PROVIDERS_EDIT,
        allow: true,
        component: ConfigComponents.PROVIDERS_EDIT,
    },
    {
        path: Routes.MAILING_LIST,
        allow: Boolean(view?.allow?.includes(Allow?.Mailing?.allow)),
        component: ConfigComponents.MAILING_LIST,
    },
    {
        path: Routes.MAILING_VIEW,
        allow: Boolean(view?.allow?.includes(Allow?.Mailing?.allow)),
        component: ConfigComponents.MAILING_VIEW
    }
];
